export default () => ({
  endpoint: window.location.protocol + '//' + window.location.hostname + window.location.pathname + (window.location.pathname.substring(-1, 1) === '/' ? '' : '/') + "/productdocuments",
  isLoading: true,
  hasError: false,

  init() {
    this.getProductDownloads();
  },

  getProductDownloads() {
    this.isLoading = true;

    fetch(this.endpoint)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        } else {
          this.hasError = true;
          throw Error(`${response.status} - ${response.statusText}`);
        }
      })
      .then(function (html) {
        let container = document.querySelector(".product__downloads");
        container.innerHTML = html;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
});
